// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconInstagram_wrapper__1xwfi","wrapper__p":"IconInstagram_wrapper__p__1PMNf"};